const CURRENT_YEAR = new Date().getFullYear();

export function Footer() {
  return (
    <footer className="bg-[#188F46] py-8 text-[#f3f6f8] mt-auto">
      <div className="container mx-auto px-4 flex flex-col md:flex-row justify-between md:items-center gap-6 md:gap-0">
        <h2 className="text-base font-bold font-noto">
          &copy; {CURRENT_YEAR}
          <br />
          Powered by Agent Srikrung
        </h2>
      </div>
    </footer>
  );
}

export default Footer;
